import {Component} from '@angular/core';

@Component({
    selector: 'app-main',
    templateUrl: './main.layout.html',
    styleUrls: ['./main.scss']
})
export class MainLayout{
}
